export enum PaymentMethodKind {
    SelfManaged = 'self_managed',
    Psp = 'psp',
}